<script>
import regions from './data.js';

export default {
  name: 'RegionSelect',
  props: {
    country: String,
    region: String,
    defaultRegion: String,
    countryName: Boolean,
    whiteList: Array,
    blackList: Array,
    regionName: Boolean,
    className: String,
    shortCodeDropdown: Boolean,
    placeholder: {
      type: String,
      default: 'Select State / Region',
    },
    disablePlaceholder: {
      type: Boolean,
      default: false,
    },
    removePlaceholder: {
      type: Boolean,
      default: false,
    },
    usei18n: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      shownRegions: [],
      selectedRegion: this.region, // Local copy of the `region` prop
      ran: false,
      showBox: false,
    };
  },
  computed: {
    valueType() {
      return this.regionName ? 'name' : 'shortCode';
    },
    autocompleteAttr() {
      return this.autocomplete ? 'address-level1' : 'off';
    },
  },
  watch: {
    country(newVal) {
      if (newVal) {
        this.shownRegions = [];

        // TODO: investigate why this line, it breaks edit view
        // this.onChangRegion('');
        this.getRegionWithCountry(newVal);
      }
    },
    region(newVal) {
      this.selectedRegion = newVal; // Sync prop changes with local data
    },
  },
  mounted() {
    const countryToSearch =
      this.country || this.defaultRegion || (this.countryName ? 'United States' : 'US');
    this.getRegionWithCountry(countryToSearch);
  },
  methods: {
    onChangRegion(region) {
      this.selectedRegion = region; // Update local state
      this.$emit('update:modelValue', region); // Notify parent
    },
    getRegionWithCountry(country) {
      if (!country) return;
      let countryRegions =
        regions.find((elem) => {
          return this.countryName
            ? elem.countryName === country
            : elem.countryShortCode === country;
        })?.regions || [];
      if (this.$i18n && this.usei18n) {
        countryRegions = countryRegions
          .map((region) => ({
            ...region,
            name: this.$t(region.name),
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
      }

      if (this.whiteList) {
        countryRegions = countryRegions.filter((region) =>
          this.whiteList.includes(region.shortCode),
        );
      }

      if (this.blackList) {
        countryRegions = countryRegions.filter(
          (region) => !this.blackList.includes(region.shortCode),
        );
      }
      this.shownRegions = countryRegions;
      this.showBox = countryRegions.length > 0 ? true : false;
      if (this.disablePlaceholder || this.removePlaceholder) {
        const firstRegion = this.shownRegions[0]?.[this.valueType];
        if (firstRegion && !this.ran) {
          this.onChangRegion(firstRegion);
          this.ran = true;
        }
      }
    },
  },
};
</script>
<template>
  <v-select
    v-if="showBox"
    v-model="selectedRegion"
    :class="className"
    :items="
      shownRegions.map((region) => ({
        title: shortCodeDropdown ? region.shortCode : region.name,
        value: countryName ? region.name : region.shortCode,
      }))
    ">
    <!-- Single prepend-item slot with conditional rendering -->
    <template v-slot:prepend-item>
      <v-list-item v-if="!disablePlaceholder && !removePlaceholder" value="">
        {{ placeholder }}
      </v-list-item>
      <v-list-item v-else-if="disablePlaceholder && !removePlaceholder" value="" disabled selected>
        {{ placeholder }}
      </v-list-item>
    </template>

    <!-- Dynamically render the region items -->
    <v-list-item v-for="(place, index) in shownRegions" :key="index" :value="place[valueType]">
      {{ shortCodeDropdown ? place.shortCode : place.name }}
    </v-list-item>
  </v-select>
</template>
